module.exports = __webpack_public_path__ + "static/media/YF40_5.6c587ec1.jpg";